<template>
  <div v-show="isShow.isTRShow" class="pageKV">
    <div class="cloud-wrapper">
      <div class="cloud1 transLeft"></div>
      <div class="cloud2 transRight"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageKV',
  props: {
    isShow: {
      type: Object
    },
    transFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showNext () {
      this.isShow.isTRShow = false
      this.isShow.isPOShow = true
    }
  },
  watch: {
    transFlag() {
      setTimeout(() => {
        this.showNext();
      }, 4400);
    }
  }
}
</script>

<style lang="less" scoped>
.pageKV {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-image: url('./trans-bg.jpg');
  .cloud-wrapper {
    position: relative;
    width: 100%;
    height: 28.125rem /* 450/16 */;
    .cloud1 {
      position: absolute;
      right: 0;
      width: 23.03125rem /* 368.5/16 */;
      height: 22.25rem /* 356/16 */;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url('./cloud1.png');
    }
    .cloud2 {
      position: absolute;
      left: 0;
      margin-top: 8.75rem /* 140/16 */;
      width: 19.46875rem /* 311.5/16 */;
      height: 18.40625rem /* 294.5/16 */;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url('./cloud2.png');
    }
  }
}

.transLeft {
  animation: transLeft .6s ease-in;
  animation-fill-mode: both;
}

@keyframes transLeft {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.transRight {
  animation: transRight .6s ease-in;
  animation-fill-mode: both;
  animation-delay: 2s;
}

@keyframes transRight {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

</style>
